// @ts-nocheck

// Aoo
import styled from 'styled-components';

// Components
import Linker from 'app/shared/modules/Linker';

// Misc / utils
import { font } from 'app/shared/styles/_fontsize';

const StyledLinker = styled(Linker)`
  ${font.sm};
  margin: 0 8px;
  line-height: 28px;
`;

const StyledUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledLi = styled.li`
  display: inline;
`;

const CrossbrandFooter = () => {
  return (
    <StyledUl>
      <StyledLi>
        <StyledLinker
          className="CrossbrandFooter-link"
          linkType="inverted"
          data-footer-page="Zillow-Crossbrand-Footer"
          target="_blank"
          rel="noopener"
          to="https://www.zillowgroup.com/"
        >
          Zillow Group® Brands:
        </StyledLinker>
      </StyledLi>
      <StyledLi>
        <StyledLinker
          className="CrossbrandFooter-link"
          linkType="inverted"
          data-footer-page="Zillow-Crossbrand-Footer"
          target="_blank"
          rel="noopener"
          to="https://www.zillow.com/"
        >
          Zillow
        </StyledLinker>
      </StyledLi>
      <StyledLi>
        <StyledLinker
          className="CrossbrandFooter-link"
          linkType="inverted"
          data-footer-page="Trulia-Crossbrand-Footer"
          target="_blank"
          rel="noopener"
          to="https://www.trulia.com/"
        >
          Trulia
        </StyledLinker>
      </StyledLi>
      <StyledLi>
        <StyledLinker
          className="CrossbrandFooter-link"
          linkType="inverted"
          data-footer-page="StreetEasy-Crossbrand-Footer"
          target="_blank"
          rel="noopener"
          to="https://streeteasy.com/"
        >
          StreetEasy
        </StyledLinker>
      </StyledLi>
      <StyledLi>
        <StyledLinker
          className="CrossbrandFooter-link"
          linkType="inverted"
          data-footer-page="OutEast-Crossbrand-Footer"
          target="_blank"
          rel="noopener"
          to="https://www.outeast.com/"
        >
          Out East
        </StyledLinker>
      </StyledLi>
    </StyledUl>
  );
};

export default CrossbrandFooter;
